import React, { Component } from "react";
import PropTypes from "prop-types";
import "./donut.scss";

class Donut extends Component {
  render() {
    const halfsize = this.props.size * 0.5;
    const radius = halfsize - this.props.strokewidth * 0.5;
    const circumference = 2 * Math.PI * radius;
    const strokeval = (this.props.value * circumference) / 100;
    const dashval = Math.abs(strokeval) + " " + circumference;

    const trackstyle = { strokeWidth: this.props.strokewidth };
    const indicatorstyle = {
      strokeWidth: this.props.strokewidth,
      strokeDasharray: dashval
    };
    const rotateval = "rotate(-90 " + halfsize + "," + halfsize + ")";

    return (
      <svg
        width={this.props.size}
        height={this.props.size}
        className="donutchart"
      >
        <circle
          r={radius}
          cx={halfsize}
          cy={halfsize}
          transform={rotateval}
          style={trackstyle}
          className="donutchart-track"
        >
          {/* <title>{this.props.label1}</title> */}
        </circle>
        <circle
          r={radius}
          cx={halfsize}
          cy={halfsize}
          transform={rotateval}
          style={indicatorstyle}
          className="donutchart-indicator"
        >
          <title>{(this.props.value).toFixed(2)}%</title>
        </circle>
        <line
          x1={halfsize - 40}
          y1={halfsize + 10}
          x2={halfsize + 40}
          y2={halfsize + 10}
          className="donutchart-line"
        />
        <text
          className="donutchart-text"
          x={halfsize}
          y={halfsize}
          style={{ textAnchor: "middle" }}
        >
          <tspan className="donutchart-text-val">{this.props.shortfall}</tspan>
          <tspan className="donutchart-text-percent">k</tspan>
          <tspan
            className="donutchart-text-label"
            x={halfsize}
            y={halfsize + 30}
          >
            {this.props.valuelabel}
          </tspan>
        </text>
      </svg>
    );
  }
  static defaultProps = {
    value: 0,
    valuelabel: "SHORTFALL",
    size: 300,
    strokewidth: 46,
    shortfall: 0
  };
}
Donut.propTypes = {
  value: PropTypes.number, // value the chart should show
  valuelabel: PropTypes.string, // label for the chart
  size: PropTypes.number, // diameter of chart
  strokewidth: PropTypes.number, // width of chart line
  // shortfall: PropTypes.number, // value for shortfall text
  label1: PropTypes.string,
  label2: PropTypes.string
};

export default Donut;



// WEBPACK FOOTER //
// ./src/components/common/Donut.jsx